// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__SD13s","icon":"SortAdornment_icon__1m8iP","up":"SortAdornment_up__1R0Rn","down":"SortAdornment_down__3WICi","active":"SortAdornment_active__3EAm9"};